/**
 * Tasks can have the following states:
 * - `IDLE`: The default resting state before `start()` is called.
 * - `TASK_CREATED`: An asset has been created on the BE.
 * - `UPLOADING`: An asset is uploading to the S3 bucket.
 * - `DOWNLOADING`: Support for integrations.
 * - `REMOTE_ORIGIN`: An asset was uploaded by another user.
 * - `TRANSFER_PARTS_COMPLETE`: Client side is done uploading to S3
 * - `CHECKSUM_COMPLETE`: [**not supported**] Compare and verify the integrity of the file with the xxHash from the Backend compared to local file.
 * - `CANPREVIEW`: Asset has a previewable thumbnail available.
 * - `CANVIEW`: There is a working transcode available to view this asset both in the grid and viewer
 * - `TRANSCODE_COMPLETE`: [**not supported**] the transcodes are all complete for the asset.
 * - `CANCELED`: The batch was canceled
 * - `FAILED`: The entire batch Failed to create destination or upload to S3.
 * - `DEACTIVATED`: The task is no longer needed, as we have a complete representation from the backend.
 *
 * - Happy path for tasks:
 *   - IDLE -> TASK_CREATED -> TRANSFER_PARTS_COMPLETE -> CANPREVIEW -> CANVIEW
 */
export enum TransferJobTaskStatus {
  IDLE = 1,
  TASK_CREATED,
  UPLOADING,
  DOWNLOADING,
  REMOTE_ORIGIN,
  DEVICE_UPLOADING,
  TRANSFER_PARTS_COMPLETE,
  CHECKSUM_COMPLETE,
  CANPREVIEW,
  CANVIEW,
  TRANSCODE_COMPLETE,
  CANCELED,
  FAILED,
  DEACTIVATED,
}
